import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';

/**
 * Uma automação de voz: a campanha de `/#/campaigns` que tem pelo menos uma
 * sequência do tipo ligação. É o que o autocomplete da aba "Automações" lista —
 * campanha só de SMS não aparece, porque nunca vai discar.
 */
export interface AutomationCall {
  id: string;
  name: string;
  active: boolean;
  /** Quantas sequências de voz a automação tem (passos que discam). */
  voice_sequences_count: number;
}

/**
 * Mesmas faixas de desfecho de `BroadcastCallMetrics` — a classificação é a
 * mesma no backend (CallMetricsService), então os cards das duas abas contam a
 * mesma coisa e são comparáveis.
 *
 * O que muda é o objeto contado (`total_automations` no lugar de
 * `total_broadcasts`) e, principalmente, a JANELA: aqui o período filtra a data
 * da ligação, enquanto na aba Broadcasts filtra a criação do disparo. Uma
 * automação criada há um ano continua discando hoje — filtrar pela criação
 * devolveria zero justamente para o funil mais ativo da conta.
 */
export interface AutomationCallMetrics {
  total_calls: number;
  total_refused: number;
  total_answered_hangup: number;
  total_answered_dtmf: number;
  total_answered_listened: number;
  /** Automações que efetivamente discaram no período. */
  total_automations: number;
  /** Passos de voz que discaram no período (uma automação pode ter vários). */
  total_sequences: number;
}

@Injectable({ providedIn: 'root' })
export class AutomationCallService {

  private baseUrl = `${environment.apiUrl}/automation-calls`;

  constructor(private http: HttpClient) { }

  /**
   * Lista as automações de voz da conta. Sem paginação, como o `getAll(1, 500)`
   * da aba Broadcasts: é um autocomplete, e o front filtra em memória.
   */
  getAll(): Observable<{ data: AutomationCall[] }> {
    return this.http.get<{ data: AutomationCall[] }>(this.baseUrl);
  }

  getMetrics(startDate: string, endDate: string, campaignId?: string): Observable<AutomationCallMetrics> {
    let url = `${this.baseUrl}/metrics?start_date=${startDate}&end_date=${endDate}`;
    if (campaignId) {
      url += `&campaign_id=${campaignId}`;
    }
    return this.http.get<AutomationCallMetrics>(url);
  }
}
